// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../public/static/img/portraits.jpg";
import ___CSS_LOADER_URL_IMPORT_1___ from "../../../../public/static/img/cr_logo_default.svg";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") repeat scroll left top #1c455f;\n  font-family: Open Sans Eas, sans-serif;\n}\nheader {\n  background: #fff;\n  border-bottom: 1px solid #ccd0d3;\n  padding: 20px 35px;\n  padding-top: 25px;\n}\n.logo-1PyEz {\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") no-repeat;\n  background-size: contain;\n  display: inline-block;\n  height: 45px;\n  width: 180px;\n}\n.form-tnLxB {\n  background: #fff;\n  border: 1px solid #cdcdcd;\n  border-radius: 3px;\n  margin: 100px auto 20px;\n  height: 400px;\n  width: 685px;\n}\n.title-Jo22H {\n  text-align: center;\n  font-size: 30px;\n  font-weight: bold;\n  margin-top: 50px;\n}\n.enter-text-KSAJx {\n  margin-top: 40px;\n  font-size: 20px;\n}\n.fields-KMeAw {\n  text-align: center;\n}\n.input-url-FNid2 {\n  background: #fff;\n  border: none;\n  border-bottom: 1px solid #ccd0d3;\n  font-size: 20px;\n  outline: none;\n  overflow: hidden;\n  text-align: right;\n  margin-left: -10px;\n  margin-right: 5px;\n  padding-right: 5px;\n  height: 32px;\n  width: auto;\n  min-width: 100px;\n  max-width: 210px;\n}\n.input-url-FNid2::-ms-clear {\n  display: none;\n}\n.input-url-FNid2::placeholder {\n  color: #d3d3d3;\n}\n.input-url-FNid2:focus {\n  border-bottom: 1px solid #119264;\n}\n.button-container-ciWsm {\n  text-align: center;\n  margin-top: 40px;\n}\n.button-q9mWY {\n  background-color: #008859;\n  border: 0;\n  border-radius: 4px;\n  border-bottom: 2px solid #008859;\n  color: #fff;\n  cursor: pointer;\n  font-family: Open Sans Eas, sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  display: inline-block;\n  line-height: 24px;\n  text-align: center;\n  padding: 6px 40px;\n  height: 36px;\n  outline: none;\n}\n.button-q9mWY:active {\n  background-color: #005538;\n}\n.button-q9mWY:focus {\n  border-bottom: 2px solid #119264;\n}\n.button-q9mWY.disabled-h27BT {\n  cursor: default;\n  opacity: 0.65;\n}\n", "",{"version":3,"sources":["webpack://./app/_common/siteEntry/main/siteEntryComponent.less"],"names":[],"mappings":"AAEA;EAEI,kFAAA;EACA,sCAAA;AA8GJ;AAjHA;EAOI,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;AA6GJ;AAvHA;EAcI,6DAAA;EACA,wBAAA;EACA,qBAAA;EAEA,YAAA;EACA,YAAA;AA2GJ;AA9HA;EAuBI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EAEA,aAAA;EACA,YAAA;AAyGJ;AAtIA;EAiCI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAwGJ;AA5IA;EAwCI,gBAAA;EACA,eAAA;AAuGJ;AAhJA;EA6CI,kBAAA;AAsGJ;AAnJA;EAiDI,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAmGJ;AAjGI;EACE,aAAA;AAmGN;AAhGI;EACE,cAAA;AAkGN;AA/FI;EACE,gCAAA;AAiGN;AA5KA;EAgFI,kBAAA;EACA,gBAAA;AA+FJ;AAhLA;EAqFI,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AA8FJ;AA5FI;EACE,yBAAA;AA8FN;AA5FI;EACE,gCAAA;AA8FN;AA5FI;EACE,eAAA;EACA,aAAA;AA8FN","sourcesContent":["@import \"@cirrus/legacy/app-components/app/styles/colors/colors-default.less\";\n\n:local {\n  body {\n    background: url(/public/static/img/portraits.jpg) repeat scroll left top #1c455f;\n    font-family: Open Sans Eas, sans-serif;\n  }\n\n  header {\n    background: @clr-white;\n    border-bottom: 1px solid @clr-gray-220;\n    padding: 20px 35px;\n    padding-top: 25px;\n  }\n\n  .logo {\n    background: url(/public/static/img/cr_logo_default.svg) no-repeat;\n    background-size: contain;\n    display: inline-block;\n\n    height: 45px;\n    width: 180px;\n  }\n\n  .form {\n    background: @clr-white;\n    border: 1px solid @clr-gray-221;\n    border-radius: 3px;\n    margin: 100px auto 20px;\n\n    height: 400px;\n    width: 685px;\n  }\n\n  .title {\n    text-align: center;\n    font-size: 30px;\n    font-weight: bold;\n    margin-top: 50px;\n  }\n\n  .enter-text {\n    margin-top: 40px;\n    font-size: 20px;\n  }\n\n  .fields {\n    text-align: center;\n  }\n\n  .input-url {\n    background: @clr-white;\n    border: none;\n    border-bottom: 1px solid @clr-gray-220;\n    font-size: 20px;\n    outline: none;\n    overflow: hidden;\n    text-align: right;\n\n    margin-left: -10px;\n    margin-right: 5px;\n    padding-right: 5px;\n\n    height: 32px;\n    width: auto;\n    min-width: 100px;\n    max-width: 210px;\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::placeholder {\n      color: @clr-gray-211;\n    }\n\n    &:focus {\n      border-bottom: 1px solid @clr-green-505;\n    }\n  }\n\n  .button-container {\n    text-align: center;\n    margin-top: 40px;\n  }\n\n  .button {\n    background-color: @clr-green-300;\n    border: 0;\n    border-radius: 4px;\n    border-bottom: 2px solid @clr-green-300;\n    color: @clr-white;\n    cursor: pointer;\n    font-family: Open Sans Eas, sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    display: inline-block;\n    line-height: 24px;\n    text-align: center;\n    padding: 6px 40px;\n    height: 36px;\n    outline: none;\n\n    &:active {\n      background-color: darken(@clr-green-300, 10%);\n    }\n    &:focus {\n      border-bottom: 2px solid @clr-green-505;\n    }\n    &.disabled {\n      cursor: default;\n      opacity: 0.65;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"logo": "logo-1PyEz",
	"form": "form-tnLxB",
	"title": "title-Jo22H",
	"enterText": "enter-text-KSAJx",
	"fields": "fields-KMeAw",
	"inputUrl": "input-url-FNid2",
	"buttonContainer": "button-container-ciWsm",
	"button": "button-q9mWY",
	"disabled": "disabled-h27BT"
};
export default ___CSS_LOADER_EXPORT___;
